<template>
  <div>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          color="blue-grey"
          v-on="on"
          x-small
          dark
          @click="$refs.inputFile.click()"
        >
          <v-icon small style="margin-right: 5px">mdi-arrow-up-circle</v-icon>
          Agregar documento
        </v-btn>
      </template>
      <span>Cargar documento</span>
    </v-tooltip>

    <input
      type="file"
      ref="inputFile"
      style="display: none"
      @input="subirDocumento"
    />

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="blue-grey" dark>
        <v-card-text>
          Cargando documento - {{ progreso }}%
          <v-progress-linear
            color="white"
            class="mb-0"
            :value="progreso"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { subirDocumentoService } from "./documentosDepara.service";

export default {
  name: "subirDocumento",
  props: ["id"],
  components: {},
  computed: {
    ...mapGetters(["httpURL", "sessionToken", "userId"]),
  },
  data() {
    return {
      loading: false,
      progreso: 0,
      error: false,
    };
  },
  mounted() {
    this.idDepara = this.$route.params.id;
  },
  methods: {
    async subirDocumento(event) {
      try {
        let file = event.target.files[0];
        const formData = new FormData();
        formData.append("archivo", file);

        const uploadHandler = {
          onUploadProgress: (progressEvent) =>
            (this.progreso =
              (progressEvent.loaded * 100) / progressEvent.total),
        };

        const serverResponse = await subirDocumentoService(
          this.idDepara,
          formData,
          uploadHandler
        );
        this.loading = false;
        if (!serverResponse.ok)
          this.$systemErrorMessage(serverResponse.mensaje);
        else {
          this.$notify({
            group: "gral_notif",
            type: "success",
            duration: 1500,
            speed: 500,
            text: serverResponse.mensaje,
          });
          this.$emit("documentoCargado", serverResponse.nuevoDocumento);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
  },
};
</script>